import AddHorario from 'components/horarios/AddHorario'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewAddHorario = () => {
  return (
    <>
        <Row>
            <Col>
               <AddHorario></AddHorario>
            </Col>
        </Row>

    </>
  )
}

export default ViewAddHorario